import React, {useState, useEffect} from "react";

import DomainSearch from "./components/DomainSearch/DomainSearch.jsx";
import IPSearch from "./components/IPSearch/IPSearch.jsx";
import EmailSearch from "./components/EmailSearch/EmailSearch.jsx";

import {getValidations} from "./utils/validations.js";

const SwitchSearch = ({query, trigger, activeLine, setLineLinks}) => {
    const [validations, setValidations] = useState({});

    useEffect(() => {
        if (trigger && query) {
            setValidations(getValidations(query))
        }
    }, [trigger, query])

    const isValidations = (values) => Object.values(values).some(values => values === true)

    return (
        <>
            {isValidations(validations) && (
                <div>
                    {validations?.domain && <DomainSearch query={query} activeLine={activeLine} setLineLinks={setLineLinks}/>}
                    {validations?.ip && <IPSearch query={query} activeLine={activeLine} setLineLinks={setLineLinks}/>}
                    {validations?.email && <EmailSearch query={query} activeLine={activeLine} setLineLinks={setLineLinks}/>}
                </div>
            )}
        </>
    )
}

export default SwitchSearch;
